var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderVirtual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 92,
    viewBox: "0 0 108 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8448",
    "data-name": "Rectangle 8448",
    width: 108,
    height: 92,
    transform: "translate(786.324 202.273)",
    fill: "#f0e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 57.069,
    height: 35.656,
    rx: 4,
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    width: 57.069,
    height: 35.656,
    rx: 4,
    fill: "#dceaef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-3",
    "data-name": "SVGID",
    width: 61.454,
    height: 39.945,
    rx: 4,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Terms_and_conditions",
    "data-name": "Terms and conditions",
    transform: "translate(-786.324 -202.273)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40025",
    "data-name": "Group 40025",
    transform: "translate(787.124 205.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40011",
    "data-name": "Group 40011",
    transform: "translate(30.531 66.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M0,11.7,6.6,7.691V0L0,4.021Z",
    transform: "translate(6.599 3.9)",
    fill: "#fcea80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M6.6,11.7,0,7.691V0L6.6,4.021Z",
    transform: "translate(0 3.883)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M0,3.942,6.6,0l6.6,3.942L6.6,7.948Z",
    transform: "translate(0 0.001)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40012",
    "data-name": "Group 40012",
    transform: "translate(0 15.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36113",
    "data-name": "Path 36113",
    d: "M7.435,129.048.1,121.9l7.335,4.491Z",
    transform: "translate(-0.094 -114.769)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36114",
    "data-name": "Path 36114",
    d: "M125,129.018l7.315-7.152L125,126.354Z",
    transform: "translate(-117.688 -114.739)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36115",
    "data-name": "Path 36115",
    d: "M7.312,0,0,7.136l7.312,4.481Z",
    transform: "translate(0 0)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36116",
    "data-name": "Path 36116",
    d: "M125,0l7.312,7.136L125,11.617Z",
    transform: "translate(-117.688 0)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40013",
    "data-name": "Group 40013",
    transform: "translate(88.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7-2",
    "data-name": "Fill 7",
    d: "M0,11.7,6.6,7.691V0L0,4.021Z",
    transform: "translate(6.598 3.899)",
    fill: "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8-2",
    "data-name": "Fill 8",
    d: "M6.6,11.7,0,7.691V0L6.6,4.021Z",
    transform: "translate(0 3.882)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9-2",
    "data-name": "Fill 9",
    d: "M0,3.942,6.6,0l6.6,3.942L6.6,7.948Z",
    transform: "translate(0)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40024",
    "data-name": "Group 40024",
    transform: "translate(21.24 11.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40023",
    "data-name": "Group 40023",
    transform: "translate(-2.39 -2.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_39986",
    "data-name": "Mask Group 39986",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 33.875, 7.637)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40017",
    "data-name": "Group 40017",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36117",
    "data-name": "Path 36117",
    d: "M0,0H57.07V35.656H0Z",
    transform: "translate(0 0)",
    fill: "#f8f8f8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_39987",
    "data-name": "Mask Group 39987",
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 25.205, 3.685)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40021",
    "data-name": "Group 40021",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36133",
    "data-name": "Path 36133",
    d: "M0,0H57.07V35.656H0Z",
    transform: "translate(0 0)",
    fill: "#dceaef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40022",
    "data-name": "Group 40022",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 10.339, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_39988",
    "data-name": "Mask Group 39988",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36149",
    "data-name": "Path 36149",
    d: "M0,0H61.744V40.305H0Z",
    transform: "translate(-0.145 -0.18)",
    fill: "#6c8bf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_66",
    "data-name": "Intersection 66",
    transform: "translate(27.868 -0.178)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.585,40.3,0,16.222,9.152,0H33.729V40.3Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.72906112670898 40.30480194091797 L 33.72906112670898 9.704590411274694e-07 L 9.152132034301758 9.704590411274694e-07 L 2.470703066137503e-06 16.22178077697754 L 13.58477210998535 40.30480194091797 L 33.72906112670898 40.30480194091797 M 34.72906112670898 41.30480194091797 L 13.000732421875 41.30480194091797 L -1.148147583007812 16.22173118591309 L 8.568142890930176 -0.9999990463256836 L 34.72906112670898 -0.9999990463256836 L 34.72906112670898 41.30480194091797 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_67",
    "data-name": "Intersection 67",
    transform: "translate(-0.147 11.096)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,29.03V11.352A24.8,24.8,0,0,1,20.711,0C34.548,0,45.765,11.634,45.765,25.979a27.215,27.215,0,0,1-.172,3.051Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.59383773803711 29.02997779846191 C 45.70665740966797 28.02953720092773 45.76547622680664 27.0117073059082 45.76547622680664 25.97945785522461 C 45.76547622680664 11.63371658325195 34.54765701293945 -3.008117573699565e-06 20.71082878112793 -3.008117573699565e-06 C 12.10362815856934 -3.008117573699565e-06 4.510658264160156 4.498647212982178 -1.886596692202147e-06 11.35164737701416 L -1.886596692202147e-06 29.02997779846191 L 45.59383773803711 29.02997779846191 M 46.48740768432617 30.02997779846191 L -1.000001907348633 30.02997779846191 L -1.000001907348633 11.052077293396 L -0.8353018760681152 10.80184745788574 C 1.507578134536743 7.242337226867676 4.677098274230957 4.279427051544189 8.330608367919922 2.233447074890137 C 12.10794830322266 0.1181069910526276 16.38896751403809 -1.000002980232239 20.71082878112793 -1.000002980232239 C 24.23213768005371 -1.000002980232239 27.64840888977051 -0.2846630215644836 30.8647289276123 1.126147031784058 C 33.96822738647461 2.487467050552368 36.75470733642578 4.435427188873291 39.14678955078125 6.915916919708252 C 41.53634643554688 9.393796920776367 43.41225814819336 12.27864742279053 44.72241973876953 15.49034690856934 C 46.07808685302734 18.81361770629883 46.76547622680664 22.34266662597656 46.76547622680664 25.97945785522461 C 46.76547622680664 27.03098678588867 46.70560836791992 28.09502792358398 46.58753967285156 29.14203643798828 L 46.48740768432617 30.02997779846191 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    d: "M3.43,0H58.314a3.43,3.43,0,0,1,3.43,3.43V36.875a3.43,3.43,0,0,1-3.43,3.43H3.43A3.43,3.43,0,0,1,0,36.875V3.43A3.43,3.43,0,0,1,3.43,0Z",
    transform: "translate(-0.145 -0.18)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_68",
    "data-name": "Intersection 68",
    transform: "translate(27.871 12.863)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.581,27.262,0,3.183,1.79,0A25.991,25.991,0,0,1,17.751,24.213a26.892,26.892,0,0,1-.173,3.049Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.57810020446777 27.26196098327637 C 17.69213104248047 26.26213073730469 17.75094032287598 25.24549102783203 17.75094032287598 24.2126522064209 C 17.75094032287598 13.19468116760254 11.12900066375732 3.777281522750854 1.789621114730835 1.44531247769919e-06 L 1.11511235445505e-06 3.182541370391846 L 13.5811710357666 27.26196098327637 L 17.57810020446777 27.26196098327637 M 18.47053146362305 28.26196098327637 L 12.99709129333496 28.26196098327637 L -1.147678852081299 3.183281421661377 L 1.34912109375 -1.256848573684692 L 2.164561033248901 -0.9270485639572144 C 4.571821212768555 0.04656144604086876 6.82374095916748 1.386021494865417 8.857761383056641 3.054141521453857 C 10.87222099304199 4.706211566925049 12.63689136505127 6.650701522827148 14.1027307510376 8.83358097076416 C 17.14362144470215 13.36194133758545 18.75094032287598 18.679931640625 18.75094032287598 24.2126522064209 C 18.75094032287598 25.26814079284668 18.69062042236328 26.33220100402832 18.5716609954834 27.37527084350586 L 18.47053146362305 28.26196098327637 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24041",
    "data-name": "Path 24041",
    d: "M9.992.061,1.187,0A1.171,1.171,0,0,0,.04,1.192L0,6.787A1.171,1.171,0,0,0,1.132,8l8.8.062a1.171,1.171,0,0,0,1.147-1.192l.039-5.6A1.171,1.171,0,0,0,9.992.061Z",
    transform: "translate(4.432 13.878)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderVirtual);
export default __webpack_public_path__ + "static/media/order_virtual.d9e972c99587084a9a6a0e4eeb3814b2.svg";
export { ForwardRef as ReactComponent };